import { useWorkOrderMergeSuggestions } from '~/app/hooks/maintenance-execution/useWorkOrderMergeSuggestions';
import { OPTIMIZER_KANBAN_PREVIEW_LIMIT } from '~/app/components/maintenance/work-orders/optimizer/constants';

export interface UseWorkOrderOptimizerTeaserArgs {
  organizationId: string;
  siteFilter: string;
}

/** Shares react-query cache with the Kanban accordion preview (same page/limit). */
export function useWorkOrderOptimizerTeaser({
  organizationId,
  siteFilter,
}: UseWorkOrderOptimizerTeaserArgs) {
  const query = useWorkOrderMergeSuggestions(organizationId, {
    page: 1,
    limit: OPTIMIZER_KANBAN_PREVIEW_LIMIT,
    ...(siteFilter ? { siteId: siteFilter } : {}),
  });

  /** Always the full total from the API meta — not the preview page size. */
  const suggestionCount = query.data?.meta?.total ?? 0;

  return {
    isLoading: query.isLoading,
    isError: query.isError,
    suggestionCount,
  };
}
